module.exports = __webpack_public_path__ + "index_pc/media/under_tip_01_nomal.8bec7ed3.aac";